export const isChunkLoadingError = (error: Error | null | undefined) =>
  /Loading\s*chunk\s*\w*\s*failed/i.test(error?.message ?? '')

export const isDynamicModuleError = (error: Error | null | undefined) =>
  /Failed to fetch dynamically imported module/i.test(error?.message ?? '')

export const isImportingModuleScriptFailedError = (
  error: Error | null | undefined
) => /Importing a module script failed/i.test(error?.message ?? '')
